import React, { FC } from "react";
import { AttributeType } from "@evergis/api";

import { NumberRangeFilter } from "./NumberRangeFilter";
import { StringCheckboxFilter } from "./StringCheckboxFilter";

import { useTableSpecialFilter } from "../../hooks/table/useTableSpecialFilter";

export const SpecialTableFilter: FC = () => {
  const [{ attributeType }] = useTableSpecialFilter();

  switch (attributeType) {
    case AttributeType.Int32:
    case AttributeType.Int64:
    case AttributeType.Double:
      return <NumberRangeFilter />;
    case AttributeType.String:
      return <StringCheckboxFilter />;
    default:
      return null;
  }
};
